<template>
  <div class="container container_01">
    <div class="hd">
      <ul class="common_nav">
        <router-link to="/workflow/apply" active-class="active" tag="li">待办理
          <a-badge :count="apply_num" :overflowCount="99999" :number-style="{ backgroundColor: '#F4826D' }"
                   style="position: absolute;"/>
        </router-link>
        <router-link to="/workflow/todo" active-class="active" tag="li">待审核
          <a-badge :count="todo_num" :overflowCount="99999" :number-style="{ backgroundColor: '#F4826D' }"
                   style="position: absolute;"/>
        </router-link>
        <router-link to="/workflow/doing" active-class="active" tag="li">进行中</router-link>
        <router-link to="/workflow/done" active-class="active" tag="li">已完成</router-link>
        <router-link to="/workflow/flow_cc" active-class="active" tag="li">抄送
          <a-badge :count="ccs_num" :overflowCount="99999" :number-style="{ backgroundColor: '#F4826D' }"
                   style="position: absolute;"/>
        </router-link>
      </ul>
      <div class="navSeach">
        <a-input-search v-model="SearchAll" style="width: 100%" placeholder="请输入事项名称或流水号" @search="onSearch"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  inject: ["isPage", "reload", "getDataSource"],
  data() {
    return {
      SearchAll: "",
      search_show: false,
    }
  },
  watch: {
    page_name: {
      handler(val, oldval) {
        if (val != oldval) {
          this.SearchAll = null;
        }
      }
    }
  },
  methods: {
    onSearch() {
      var val = this.SearchAll;
      if (!this.isPage("todo") && !this.isPage("apps") && !this.isPage("appall")) {
        this.$store.dispatch("SearchQ", {
          key: this.$route.name,
          property: "keyword",
          val,
        });
      }
      if (this.isPage("apps")) {
        val = val ? val : "all";
        this.$store.dispatch("updateQuery", {seq: val});
        this.$router.push("/workflow/appall");
      }
      if (this.isPage("appall")) {
        val = val ? val : "all";
        this.$store.dispatch("updateQuery", {seq: val});
      }
      if (this.isPage("todo")) {
        this.$store.state.apiMap[this.$route.name].query = val;
      }
    },
    signOutOidc() {
      this.$store.dispatch("oidcStore/signOutOidc");
    },
    showSearch() {
      this.search_show = !this.search_show;
      if (!this.search_now) {
        this.$store.dispatch("updateQuery", {seq: "all", tag: "all"});
      }
    }
  },
  computed: {
    page_name() {
      return this.$route.name;
    },
    ccs_num() {
      return this.$store.getters.getState.dataLength.cc;
    },
    todo_num() {
      return this.$store.getters.getState.dataLength.todo;
    },
    apply_num() {
      return this.$store.getters.getState.dataLength.apply;
    }
  }
};
</script>
<style>
.mobile .router-link-active {
  color: #000;
  font-weight: 600;
  border-bottom: 4px var(--now) solid;
}

.we_th {
  padding: 5px 0px;
  text-align: center;
}

.hd_todo {
  background: #282828;
}

.hd_todo .logo1 {
  color: #fff;
}

.logo1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

}

.hd_todo .txt {
  padding-left: 40px;
  color: #fff;
  padding-bottom: 15px;
}

.hd_todo h1 {
  padding-left: 40px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
}

.hd_todo p {
  margin-bottom: 0px;
}

.navSeach {
  padding: 10px;
  background: #ebf1ef;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/nav.vue